export const ROOT = 'wc-root';
export const HEADER_TITLE = 'wc-header-title';
export const COMMENTS_HEADER = 'wc-header';
export const SORTING_SELECTOR = 'wc-sorting-selector';
export const EMPTY_STATE_ZERO_COMMENTS_TITLE = 'es-zero-comment-title';
export const EMPTY_STATE_ZERO_COMMENTS_CONTENT = 'es-zero-comment-content';
export const COMMENT_BOX = 'comment-box';
export const COMMENT_BOX_TOP = 'comment-box-top';
export const COMMENT_BOX_BOTTOM = 'comment-box-bottom';
export const COMMENT_BOX_PLACEHOLDER = 'comment-box-placeholder';
export const COMMENT_BOX_PLACEHOLDER_TEXT = 'comment-box-placeholder-text';
export const COMMENT_BOX_RCE_WRAPPER = 'comment-box-rce-wrapper';
export const COMMENT_BOX_TOOLBAR = 'comment-box-rce-toolbar';
export const COMMENT_BOX_USERNAME = 'comment-box-username';
export const COMMENT_BOX_EMAIL = 'comment-box-email';
export const COMMENT_BOX_ERROR = 'comment-box-error';
export const IS_LOCKED = 'is-locked';
export const LOADING = 'loading';
export const LIST_ITEM = 'list-item';
export const PENDING = 'pending';
export const DELETED = 'deleted';
export const TOP_LEVEL = 'top-level';
export const REPLY = 'reply';
export const ERROR = 'error';
export const MARKED = 'marked';
export const EDITED = 'edited';
export const COMMENT_CONTENT = 'comment-content';
export const AUTHOR = 'comments-author';
export const FEATURED_BADGE = 'featured-badge';
export const PRIMARY_BTN = 'primary-btn';
export const SECONDARY_BTN = 'secondary-btn';
export const CANCEL_BTN = 'cancel-btn';
export const LOGIN_AS_MEMBER_BTN = 'login-as-member-text-button';
export const CONFIRMATION_MODAL = 'confirmation-modal';
export const REPORT_COMMENT_MODAL = 'report-comment-modal';
export const ACTIONS_MENU = 'actions-menu';
export const ACTIONS_MENU_BTN = 'actions-menu-btn';
export const ACTIONS_MENU_EDIT_BTN = 'actions-menu-edit-btn';
export const ACTIONS_MENU_DELETE_BTN = 'actions-menu-delete-btn';
export const ACTIONS_MENU_SHARE_BTN = 'actions-menu-share-btn';
export const ACTIONS_MENU_MARK_BTN = 'actions-menu-mark-btn';
export const ACTIONS_MENU_REPORT_BTN = 'actions-menu-report-btn';
export const TOAST = 'wc-toast';
export const REPLY_BTN = 'reply-btn';
export const REPLY_TEXT = 'reply-text';
export const LOAD_MORE_NEXT = 'load-more-next';
export const LOAD_MORE_PREV = 'load-more-prev';
export const LOAD_MORE_REPLIES_NEWER = 'load-more-replies-newer';
export const LOAD_MORE_REPLIES_OLDER = 'load-more-replies-older';
export const LOAD_MORE_REPLIES = 'load-more-replies';
export const WITH_LIVE = 'with-live';
export const SPINNER = 'spinner';
export const TOP_LEVEL_COMMENT_LIST = 'top-level-comment-list';
export const REPLY_LIST = 'reply-list';
export const LIST_LOADING = 'list-loading';
export const COMMENT_NOT_FOUND = 'comment-not-found';
export const DEFAULT_LIST_FETCH_ERROR = 'default-list-fetch-error';
export const LIST_FETCH_ERROR_RETRY_BUTTON = 'list-fetch-error-retry-button';
export const REPORT_REASON_RADIO_BTN_GROUP = 'report-reason-radio-button-group';
export const REPORT_REASON_DETAILS_INPUT = 'report-reason-details-input';
export const EDITED_COMMENT_INDICATOR = 'edited-comment-indicator';
export const REPLYING_TO_BTN = 'replying-to-btn';
export const SHOW_MORE_BTN = 'show-more-btn';
export const SOMEONE_IS_TYPING_START = 'someone-is-typing-start';
export const SOMEONE_IS_TYPING_END = 'someone-is-typing-end';
export const SHOW_LIVE_COMMENTS_START = 'show-live-comments-start';
export const SHOW_LIVE_COMMENTS_END = 'show-live-comments-end';
export const SHOW_LIVE_REPLIES = 'show-live-replies';
export const SHOW_LIVE_REPLIES_ROOT = 'show-live-replies-root';
export const SHOW_LIVE_REPLIES_END = 'show-live-replies-end';
export const LIVE_COMMENT_INDICATOR = 'live-comment-indicator';
export const PUBLISH_AS_GUEST_BTN = 'publish-as-guest-btn';
export const MEMBER_FOLLOW_BUTTON = 'member-follow-btn';
export const MEMBER_IS_FOLLOWED = 'member-is-followed';
export const MEMBER_LIST = 'member-list';
export const VOTE_CONTAINER = 'vote-container';
export const UPVOTE_BUTTON = 'upvote-button';
export const DOWNVOTE_BUTTON = 'downvote-button';
export const VOTE_COUNT = 'vote-count';
export const ACTIVE = 'active';
export const DISABLED = 'disabled';
export const COMMENT_FOOTER_ERROR_EDIT = 'comment-footer-error-edit';
export const COMMENT_FOOTER_ERROR_RETRY = 'comment-footer-error-retry';
export const HEADER_RATINGS = 'header-ratings';
export const RATING_DISPLAY = 'ratings-display';
export const RATING_INPUT = 'rating-input';
export const USER_ACTIONS_MENU = 'user-action-menu';
export const USER_AUTH_LOGIN = 'user-auth-login';
export const USER_AUTH_LOGOUT = 'user-auth-logout';
export const EDIT_HISTORY_MODAL = 'edit-history-modal';
export const LOAD_NEXT_HISTORY = 'load-next-history';
export const HISTORY_ITEM = 'history-item';
export const EDIT_HISTORY_LIST = 'edit-history-list';
export const PENDING_COMMENT_MODAL = 'pending-comment-modal';
export const BLOCKED_MODERATED_COMMENT_MODAL = 'block-moderated-comment-modal';
export const SKELETON = 'skeleton';
//# sourceMappingURL=data-hooks.js.map